angular
    .module('backOffice')
    .controller('ConfigureWausauStatementsController', configureWausauStatementsController);

configureWausauStatementsController.$inject = [
    '$scope',
    '$modalInstance',
    'modalService',
    'configurationService',
    'productFeatureId',
    'productFeatureStatus',
    'canEdit',
    'toaster',
];

function configureWausauStatementsController(
    $scope,
    $modalInstance,
    modalService,
    configurationService,
    productFeatureId,
    productFeatureStatus,
    canEdit,
    toaster
) {
    $scope.productFeatureId = productFeatureId;
    $scope.productFeatureStatus = productFeatureStatus;
    $scope.canEdit = canEdit;

    $scope.productFeature = {};

    $scope.setForm = setForm;
    $scope.save = save;
    $scope.cancel = cancel;

    function setForm(form) {
        $scope.form = form;
    }

    function save() {
        $scope.productFeature.status = productFeatureStatus;

        configurationService
            .saveProductFeature($scope.productFeatureId, $scope.productFeature)
            .then(response => {
                toaster.save('Wausau eStatements Configuration');
                $modalInstance.close();
            });
    }

    function cancel() {
        if ($scope.form.$dirty) {
            const modalOptions = {
                closeButtonText: 'Continue Editing',
                actionButtonText: 'OK',
                headerText: 'Cancel',
                bodyText: 'Are you sure you want to cancel the changes?',
                submit(result) {
                    cancelModalInstance.dismiss();
                    $modalInstance.dismiss();
                },
            };
            var cancelModalInstance = modalService.showModal({}, modalOptions);
        } else {
            $modalInstance.dismiss();
        }
    }

    function init() {
        $scope.productFeature = {
            productDisplayName: '',
            errorMessage: '',
            noStatementMessage: '',
            selectAccountLabel: '',
        };

        loadProductFeature();
    }

    function loadProductFeature() {
        configurationService.getProductFeatureDetails($scope.productFeatureId).then(response => {
            $scope.productFeature = response;
        });
    }

    init();
}
